import { DEV } from "solid-js"
import { freeze } from "../util/Object"

export type EightDirectionCharLowerCase = 's' | 'se' | 'e' | 'ne' | 'n' | 'nw' | 'w' | 'sw'

export type EightDirectionIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7

const eightDirectionCharsLowerCase : ReadonlyArray<EightDirectionCharLowerCase> = [
  's',
  'se',
  'e',
  'ne',
  'n',
  'nw',
  'w',
  'sw',
] as const

if (DEV) {
  freeze(eightDirectionCharsLowerCase)
}

export default eightDirectionCharsLowerCase